import { TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import Linkify from 'linkify-react';
import type { IntermediateRepresentation } from 'linkifyjs';
import { FC, memo } from 'react';
import styles from './LinkifiedText.module.scss';

const cx = classnames.bind(styles);

const linkifyOptions = {
  render: {
    url: ({ attributes, content }: IntermediateRepresentation) => {
      const href: string | undefined =
        typeof attributes.href === 'string' ? attributes.href : undefined;
      if (!href) {
        return <>{content}</>;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { href: _href, ...props } = attributes;
      return (
        <TextLink {...props} className={cx('link')} href={href} target='_blank'>
          {content}
        </TextLink>
      );
    },
  },
};

export type Props = {
  text: string;
};

export const LinkifiedText: FC<Props> = memo(({ text }) => {
  return (
    <div className={cx('container')}>
      <Linkify options={linkifyOptions}>{text}</Linkify>
    </div>
  );
});

LinkifiedText.displayName = 'LinkifiedText';
